import { licenseApi } from "../../../api/apiClient";

function getLicense(id) {
  return licenseApi.get(`/bank/license/${id}`);
}

function updateLicense(id, data) {
  return licenseApi.post(`/bank/license/${id}/request-update`, data);
}

function changeLicense(id, data) {
  return licenseApi.post(`/bank/license/${id}/change`, data);
}

function customizeModules(id, data) {
  return licenseApi.post(`/bank/license/${id}/toggle`, data);
}

function getLicenseHistory(id) {
  return licenseApi.get(`/bank/license/${id}/history`);
}

function getModules() {
  return licenseApi.get(`/shared/license/modules`);
}

function validateLicense(id, data) {
  return licenseApi.post(`/bank/license/validate/${id}`, data);
}

function inValidateLicense(id, data) {
  return licenseApi.post(`/bank/license/invalidate/${id}`, data);
}

export const licenseServices = {
  getLicense,
  updateLicense,
  changeLicense,
  customizeModules,
  getLicenseHistory,  
  getModules,
  validateLicense,
  inValidateLicense,
};
